var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('h2',{staticClass:"text-center"},[_vm._v("Users game permission")]),_c('UsersTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }